import React from "react"
import { AiPricingDiagnosis } from "../../../../types"

interface DiagnosisResultsProps {
  diagnosis: AiPricingDiagnosis
}

export const DiagnosisResults: React.FC<DiagnosisResultsProps> = ({
  diagnosis
}) => {
  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-6">Pricing Failed</h2>

      {/* Metadata Section */}
      <div className="space-y-3 mb-6">
        <div className="flex">
          <span className="text-gray-600 w-32">Engine:</span>
          <span className="text-gray-900">{diagnosis.engineType}</span>
        </div>
        <div className="flex">
          <span className="text-gray-600 w-32">Quote ID:</span>
          <span className="text-gray-900">{diagnosis.quoteId}</span>
        </div>
        <div className="flex">
          <span className="text-gray-600 w-32">Timestamp:</span>
          <span className="text-gray-900">{diagnosis.timestamp}</span>
        </div>
        <div className="flex">
          <span className="text-gray-600 w-32">Cached:</span>
          <span className="text-gray-900">
            {diagnosis.cached ? "Yes" : "No"}
          </span>
        </div>
      </div>

      {/* Summary Section */}
      <div className="mb-6">
        <h3 className="font-semibold mb-2">Summary</h3>
        <div className="border-l-4 border-gray-300 pl-4 py-2 bg-gray-50">
          <p className="text-gray-800">{diagnosis.summary}</p>
        </div>
      </div>

      {/* Root Cause Section */}
      <div className="mb-6">
        <h3 className="font-semibold mb-2">Root cause</h3>
        <div className="border-l-4 border-gray-300 pl-4 py-2 bg-gray-50">
          <p className="text-gray-800">{diagnosis.root_cause}</p>
        </div>
      </div>

      {/* Required Fixes Section */}
      <div>
        <h3 className="font-semibold mb-2">Required fixes</h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 px-4 text-gray-600 font-semibold text-sm uppercase">
                  Parameter
                </th>
                <th className="text-left py-2 px-4 text-gray-600 font-semibold text-sm uppercase">
                  Correction
                </th>
              </tr>
            </thead>
            <tbody>
              {diagnosis.fixes.map((fix, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4 align-top">
                    <div className="text-gray-900">{fix.parameter}</div>
                  </td>
                  <td className="py-3 px-4 align-top">
                    <div className="text-gray-800">{fix.required}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
